<script setup lang="ts">
/*
 * Presentational. The visible set lives in useFileTable, so both triggers and
 * the table read one source of truth - calling useColumnPreferences() here
 * would hand the menu its own copy and the table would not react to a tick.
 */
import { useI18n } from "vue-i18n";
import { FileColumn, columnLabel } from "@/ui/components/FileBrowser/columns";

const { t } = useI18n();

defineProps<{
	columns: FileColumn[];
	isColumnVisible: (key: string) => boolean;
	isColumnLocked: (key: string) => boolean;
	target?: HTMLElement | [number, number];
}>();

const isOpen = defineModel<boolean>();

const emit = defineEmits<{ toggle: [key: string]; reset: [] }>();
</script>

<template>
	<v-menu
		v-model="isOpen"
		:target="target"
		:close-on-content-click="false"
		location="bottom end"
	>
		<v-list density="compact" min-width="190">
			<v-list-item
				v-for="column in columns"
				:key="column.key"
				:disabled="isColumnLocked(column.key)"
				@click="emit('toggle', column.key)"
			>
				<template #prepend>
					<v-checkbox-btn
						:model-value="isColumnVisible(column.key)"
						:disabled="isColumnLocked(column.key)"
						density="compact"
					/>
				</template>

				<v-list-item-title>{{ columnLabel(column) }}</v-list-item-title>
			</v-list-item>

			<v-divider class="my-1" />

			<v-list-item
				:title="t('fileBrowser.resetColumns')"
				@click="emit('reset')"
			/>
		</v-list>
	</v-menu>
</template>
